import { docReady } from '../helpers/doc-ready';
let timeToEndPDP;
let countDownDatePDP;
const countdownTimerPDP = () => {
    Array.from(document.querySelectorAll('[data-pdp-combo-countdown-message]')).map((countdown) => {
        //Get the date set in Shopify
        const date = new Date(countdown.attributes['data-pdp-combo-countdown-endtime'].value);
        //When countdown is enabled
        if (countdown.attributes['data-pdp-combo-countdown-message']) {
            const contentDiv = countdown.querySelector('[data-pdp-combo-countdown-message-text]');
            countDownDatePDP = date.getTime();
            const now = new Date().getTime();
            timeToEndPDP = countDownDatePDP - now;
            if (timeToEndPDP >= 0) {
                contentDiv.classList.add('show');
                contentDiv.innerHTML = getCountDownStringPDP();
            }
            else if (timeToEndPDP <= 0) {
                contentDiv.classList.remove('show');
                countdown.remove();
            }
            const countDownTimer = setInterval(() => {
                contentDiv.innerHTML = getCountDownStringPDP();
                //If the countdown has ended, revert to default
                if (timeToEndPDP <= 0) {
                    contentDiv.classList.remove('show');
                    countdown.remove();
                    clearInterval(countDownTimer);
                }
            }, 1000);
        }
    });
};
const getCountDownStringPDP = () => {
    const now = new Date().getTime();
    timeToEndPDP = countDownDatePDP - now;
    const days = Math.floor(timeToEndPDP / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeToEndPDP % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeToEndPDP % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeToEndPDP % (1000 * 60)) / 1000);
    const dayString = `<span class="timer__column"><span class="column__heading">Days</span><span class="column__counter h1">${days < 10 ? `0${days}` : `${days}`}:</span></span>`;
    const hoursString = `<span class="timer__column"><span class="column__heading">Hours</span><span class="column__counter h1">${hours < 10 ? `0${hours}` : `${hours}`}:</span></span>`;
    const minutesString = `<span class="timer__column"><span class="column__heading">Mins</span><span class="column__counter h1">${minutes < 10 ? `0${minutes}` : `${minutes}`}:</span></span>`;
    const secondsString = `<span class="timer__column"><span class="column__heading">Secs</span><span class="column__counter h1">${seconds < 10 ? `0${seconds}` : `${seconds}`}</span></span>`;
    return `${dayString}${hoursString}${minutesString}${secondsString}`;
};
docReady(() => {
    countdownTimerPDP();
});
